import { SessionStorage } from '@ibe/services';
import {
  ApiBookedItem,
  ApiDurationInfo,
  ApiDurationType,
  ApiGetPackageComponentsRQ,
  ApiGetPackageComponentsRS,
  ApiImageContainer,
  ApiItemType,
  ApiPriceModifierType,
  ApiStationSupplement,
  ApiTraveler
} from '@ibe/api';
import { ProductIBEMode } from '../Checkout/CheckoutStore';
import { GlobalFilterParams } from '../../Pages/Products/PBusFilters';

export const PACKAGE_ID_KEY = 'thg-package-id';

const PRODUCT_PAGE_FILTERS = 'thg-product-page-filters';

const MMA_AVAILABLE_COMPONENTS = 'thg-mma-available-components';

export const packageIdSessionStorage = new SessionStorage<{
  packageId: string;
  packageCode: string;
  numberOfTravelers: number;
  groupSize?: string;
  stationCodes?: string[];
  stationSupplements?: ApiStationSupplement[];
}>(PACKAGE_ID_KEY);

export const packageFilterSessionStorage = new SessionStorage<GlobalFilterParams>(
  PRODUCT_PAGE_FILTERS
);

export const mmaAvailableComponentSessionStorage = new SessionStorage<{
  res: ApiGetPackageComponentsRS;
  req: ApiGetPackageComponentsRQ;
}>(MMA_AVAILABLE_COMPONENTS);

export const VALID_PROMOTION_CODE_DATA = 'thg-valid-promotion-code-data';

const PRODUCT_DETAILS_PAGE_URL = 'thg-product-details-page-url';

const WHITELABEL_SEASON = 'thg-whitelabel-season';

const TRAVELERS_SAME_ADDRESS_FORMS = 'thg-travelers-same-address-forms';

const PRODUCT_IBE_MODE = 'thg-product-ibe-mode';

export const BUS_SESSION_STORAGE_KEYS = {
  selectedPostCode: 'selectedPostCode',
  selectedStations: 'selectedStations',
  busStopSelection: 'busStopSelection',
  ipGeolocationAttempted: 'ipGeolocationAttempted',
  selectedPostCodeFromGeolocation: 'selectedPostCodeFromGeolocation',
  geolocationPostCode: 'geolocationPostCode'
};

export const SELF_ARRIVAL_CODE = '00000';
export const TAXI_30KM_CODE = '00001';
export const BUS_STOPS_PERIMETER = 100;

export type ValidPromotionCode = {
  code: string;
  percentageValue?: number;
  absoluteValue?: number;
  preSign?: string;
  sign?: string;
  manuallyAdded?: boolean;
  productCode?: string;
};

export type SeasonHotelInformation = {
  code: string;
  productName: string;
  dateFrom: Date;
  dateTo: Date;
  additionalServices: string;
  groupSize: string;
  image?: ApiImageContainer;
  icon?: ApiImageContainer;
  seasonCountry?: {
    countryName: string;
  };
};

export const travelersSameAddressForms = new SessionStorage<ApiTraveler[]>(
  TRAVELERS_SAME_ADDRESS_FORMS
);

export const productIbeModeStorage = new SessionStorage<ProductIBEMode>(PRODUCT_IBE_MODE);

export const validPromotionCodeStorage = new SessionStorage<ValidPromotionCode>(
  VALID_PROMOTION_CODE_DATA
);

export const productDetailsPageUrlStorage = new SessionStorage<string>(PRODUCT_DETAILS_PAGE_URL);

export const whitelabelSeasonStorage = new SessionStorage<SeasonHotelInformation>(
  WHITELABEL_SEASON
);

export const clearStorage = (): void => {
  productDetailsPageUrlStorage.clear();
};

export const getTotalDiscount = (
  travelers: ApiTraveler[],
  bookedItems?: ApiBookedItem[] | null
): number => {
  const services = bookedItems?.filter(service => service.itemType !== ApiItemType.PACKAGE);
  const discountMap = new Map<string, number>();
  travelers.forEach(traveler => {
    discountMap.set(traveler.id, 0);
    services?.forEach(current => {
      if (
        current.priceByPersonId &&
        current.priceByPersonId[traveler.id] &&
        current.priceByPersonId[traveler.id].modifiers
      ) {
        const discount = current.priceByPersonId[traveler.id].modifiers.find(
          modifier => modifier.type === ApiPriceModifierType.DISCOUNT
        );
        if (discount) {
          discountMap.set(
            traveler.id,
            discountMap.get(traveler.id) || 0 + Math.abs(discount.absolute)
          );
        }
      }
    });
  });
  return Math.max(...discountMap.values());
};

export const computeDuration = (durationInfo: ApiDurationInfo): number => {
  return durationInfo.type === ApiDurationType.NIGHT
    ? durationInfo.duration + 1
    : durationInfo.duration;
};

export const getReducedBusStationList = (busStations: string[] | undefined): string[] => {
  if (busStations)
    return busStations.filter(item => item !== SELF_ARRIVAL_CODE && item !== TAXI_30KM_CODE);
  return [];
};
